import { ComboBoxContext } from '@acsbe/ui';
import { useContext } from 'react';

export function useComboBoxContext() {
  const context = useContext(ComboBoxContext);
  if (!context) {
    throw new Error(
      'ComboBox compound components cannot be rendered outside the ComboBox component',
    );
  }
  return context;
}
